import { Outlet } from 'react-router-dom';
import { Layout } from '@/shared/ui/Layout';
import { Wrapper } from '@/shared/ui/Wrapper';
import { PageLoader } from '@/shared/ui/PageLoader';
import { usePolicyStore } from '@/entities/Policy/model/store';

export const MainLayout = () => {
    const isLoading = usePolicyStore((state) => state.isLoading);

    if (isLoading) {
        return (
            <Wrapper>
                <PageLoader />
            </Wrapper>
        );
    }
    return (
        <Layout //
            pageSlot={<Outlet />}
        />
    );
};
